import MenuItem from '@mui/material/MenuItem'
import React, { useCallback } from 'react'

import { formatPhone } from 'utils/helper'

import { DemoCaller } from './screenPopApi'

interface DemoCallerItemProps {
  caller: DemoCaller
  onCall: (caller: DemoCaller) => void
}

const DemoCallerItem = ({ caller, onCall }: DemoCallerItemProps) => {
  const handleClick = useCallback(() => onCall(caller), [caller, onCall])

  return <MenuItem onClick={handleClick}>{`${caller.name} · ${formatPhone(caller.fromNumber)}`}</MenuItem>
}

export default DemoCallerItem
